@for (tab of links; track tab) {
  <mat-list-item class="p-0">
    <a class="w-100 nav-button" mat-button matTooltipPosition="right" [class.disabled]="tab.isDisabled"
       [class.expanded]="tab.isExpanded" [class.primary-color]="tab.isSelected"
       [disabled]="tab.isDisabled" [id]="tab.id" [lcTestId]="tab.id"
       [matTooltip]="tab.label"
       [matTooltipDisabled]="isExpanded"
       [routerLink]="[tab.path]"
       [routerLinkActive]="'selected primary-color'"
       [routerLinkActiveOptions]="{exact: tab.exactMatch}"
       (isActiveChange)="onActiveLinkChanged($event, tab)"
    >
      <div class="nav-link-content fx-row y-center fx-gap-sm" [class.x-center]="!isExpanded">
        <mat-icon class="fx-0-0">{{ tab.svgPath }}</mat-icon>
        @if (isExpanded) {
          <span class="text-left w-100 d-inline-block">{{ tab.label }}</span>
        }
        @if (isExpanded && tab?.children?.length) {
          <button disableRipple="true" mat-icon-button (click)="onToggleExpand($event, tab);">
            <mat-icon>{{tab.isExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
          </button>
        }
      </div>
    </a>
  </mat-list-item>
  @if (tab?.children?.length) {
    <!-- NOTE: Using class.d-none instead of *ngIf because we want the (isActiveChange) to fire regardless of whether it is displayed or not -->
    @for (child of tab.children; track child) {
      <mat-list-item class="p-0" [class.d-none]="!(isExpanded && tab.isExpanded)">
        <a class="w-100 child-button nav-button" mat-button
           [class.disabled]="child.isDisabled"
           [disabled]="child.isDisabled"
           [id]="child.id"
           [routerLink]="[child.path]"
           [routerLinkActive]="'primary-color'"
           [routerLinkActiveOptions]="{exact: child.exactMatch}"
           (isActiveChange)="onActiveLinkChanged($event, child, tab)"
        >
          <div class="nav-link-content fx-row y-center fx-gap-sm" [class.x-center]="!isExpanded">
            <mat-icon class="fx-0-0">{{ child.svgPath }}</mat-icon>
            @if (isExpanded) {
              <span class="text-left w-100 d-inline-block">{{ child.label }}</span>
            }
          </div>
        </a>
      </mat-list-item>
    }
  }
}
